import { QuestionAndAnswerResource } from '@aorg/models/resources/Question/QuestionAndAnswerResource';
import api from '..';
import { ConsultationResource } from './getConsultations';

function getExpertConsultation(uuid?: string) {
  return api.get<{ data: ConsultationResource }>(
    `/api/experts/consultations/${uuid}`,
    {}
  );
}

export type { QuestionAndAnswerResource };
export default getExpertConsultation;
